<template>
    <ErrorMessage :type="errorType" />
</template>

<script setup lang="ts">
    import ErrorMessage from '@/components/layout/ErrorMessage.vue'

    const route = useRoute()
    const errorType = computed(() => route.params.type as string | undefined)
</script>
